/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_OfferInputs */



/**
* | output |
* | --- |
* | "That's everything. Ready? Let me show you around the sidebar - it's where everything in oneAI starts." |
*
* @param {Onboarding_Tour_OfferInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_offer = /** @type {((inputs?: Onboarding_Tour_OfferInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_OfferInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das war's. Bereit? Ich zeige dir die Seitenleiste - dort beginnt alles in oneAI.")
	return /** @type {LocalizedString} */ ("That's everything. Ready? Let me show you around the sidebar - it's where everything in oneAI starts.")
});